import React from 'react';
import DriversTable from './DriversTable';
import driverFlagsApproved from './misc/driverFlagsApproved';

export default function ApprovedDrivers() {
  return <DriversTable title="Approved" orderByChild="status" equalTo="approved" flags={driverFlagsApproved} />;
}
